export default {
  BAH_RATES_FETCH_START: 'BAH_RATES_FETCH_START',
  BAH_RATES_FETCH_SUCCESS: 'BAH_RATES_FETCH_SUCCESS',
  BAH_RATES_FETCH_FAILURE: 'BAH_RATES_FETCH_FAILURE',
}
